// Get siblings of an element; source https://plainjs.com/javascript/traversing/get-siblings-of-an-element-40/
const getSiblingElements = (el: Element, filter?: (el: Element) => boolean) => {
  const siblings = [];
  let sibling = el.parentNode?.firstElementChild ?? null;

  while (sibling !== null) {
    if (!filter || filter(sibling)) {
      siblings.push(sibling);
    }
    sibling = sibling.nextElementSibling;
  }

  return siblings;
};

// Scroll to the top of collapsibles after they are opened
export const initCollapsibles: DrupalBehaviorHooks['attach'] = (context) => {
  context.querySelectorAll('.collapse').forEach((elem) => {
    elem.addEventListener('shown.bs.collapse', () => {
      const header = getSiblingElements(elem, (el) => el.classList.contains('collapsible-item-heading'))[0];
      header?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    });
  });
};
